import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=3d6006dc&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"
import style0 from "./MessagesList.vue?vue&type=style&index=0&id=3d6006dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6006dc",
  null
  
)

export default component.exports